import React, { useEffect } from "react";
import ArrowUpRight from "images/arrow-up-right.png";
import Image from "components/image";
import RichText from "components/rich-text";
import Link from "helpers/link";

const SingleTrainer = ({ trainer }) => {
  const { name, image, assignedHorses } = trainer;

  return (
    <div className="" id={name.split(" ").join("_").toLowerCase()}>
      <div className="bg-white rounded-xl p-4 mb-8">
        <div className="flex sm:flex-col">
          <div className="rounded-[15px] max-w-[280px] sm:max-w-full w-full overflow-hidden border-solid border-2 border-yellow-300">
            <img src={image.src} className="w-full h-full object-cover" />
          </div>
          <div className="p-5 flex flex-col w-full sm:px-0">
            <h2 className="font-bold font-display text-[32px]">{name}</h2>
            
              {trainer?.trainerDescription ? (
                <div className="single-horse-rich">
                  <RichText data={trainer.trainerDescription} />
                  </div>
              ): (<p className="single-horse-rich">{trainer.description}</p>)}

            {assignedHorses?.length > 0 && (
              <div className="mt-auto">
                <p className="text-small text-yellow-500 font-sans ">
                  Horse in training
                </p>

                <div className="flex mt-0.5 flex-wrap gap-3.5">
                  {assignedHorses?.map((horse, index) => (
                    <div
                      key={index}
                      className="flex items-center text-sm font-sans"
                    >
                      <Link
                        className="mr-1 underline text-gray-800 font-bold"
                        to={`/horses/${horse.slug}`}
                      >
                        {horse.name}
                      </Link>
                      <img src={ArrowUpRight} alt="arrow" className="w-4 top-2" />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleTrainer;
